import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { LdapDirectoryType } from '../../../services/enums/ldap';
import HelpTooltip from '../../portal/controls/helpTooltip';
import PortalTextBox from '../../portal/portalTextBox';
import { AdditionalGroupDnTooltip, GroupObjectSchemaTooltip,
    GroupObjectFilterTooltip,
    GroupNameAttributeTooltip, GroupMemberAttributeTooltip,
    GroupMemberOfAttributeTooltip } from './ldapHelpTooltipContent';
import EditAdvancedRoleMappingButton from '../advancedRoleMappings/editAdvancedRoleMappingButton';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import GroupMembersAttributeOriginDropdownContainer from './groupMembersAttributeOriginDropdownContainer';

@inject('translationsStore') @observer
export default class GroupSchemaSettingsSection extends Component {

    currentLdapStore = this.props.currentLdapStore;
    ldapValidator = this.props.ldapValidator;
    translations = this.props.translationsStore;
    t = this.translations.translate;
    
    onChangeAdditionalGroupDn = (e) => this.currentLdapStore.setAdditionalGroupDn(e.target.value);
    onBlurAdditionalGroupDn = (e) => {
        this.currentLdapStore.setAdditionalGroupDn(e.target.value.trim());
    }

    onChangeGroupObjectClass = (e) => this.currentLdapStore.setGroupObjectClass(e.target.value);
    onBlurGroupObjectClass = (e) => {
        this.currentLdapStore.setGroupObjectClass(e.target.value.trim());
        this.ldapValidator.validateGroupObjectClass(this.currentLdapStore.groupObjectClass);
    }

    onChangeGroupObjectFilter = (e) => this.currentLdapStore.setGroupObjectFilter(e.target.value);
    onBlurGroupObjectFilter = (e) => {
        this.currentLdapStore.setGroupObjectFilter(e.target.value.trim());
        this.ldapValidator.validateGroupObjectFilter(this.currentLdapStore.groupObjectFilter);
    }

    onChangeGroupNameAttribute = (e) => this.currentLdapStore.setGroupNameAttribute(e.target.value);
    onBlurGroupNameAttribute = (e) => {
        this.currentLdapStore.setGroupNameAttribute(e.target.value.trim());
        this.ldapValidator.validateGroupNameAttribute(this.currentLdapStore.groupNameAttribute);
    }

    onChangeGroupMembersAttribute = (e) => this.currentLdapStore.setGroupMembersAttribute(e.target.value);
    onBlurGroupMembersAttribute = (e) => {
        this.currentLdapStore.setGroupMembersAttribute(e.target.value.trim());
        this.ldapValidator.validateGroupMembersAttribute(this.currentLdapStore.groupMembersAttribute);
    }

    onChangeUserMembershipAttribute = (e) => this.currentLdapStore.setUserMembershipAttribute(e.target.value);
    onBlurUserMembershipAttribute = (e) => {
        this.currentLdapStore.setUserMembershipAttribute(e.target.value.trim());
    }

    onChangeGroupMembersAttributeSource = (e) => this.currentLdapStore.setGroupMembersAttributeSource(e.target.innerText);
    onBlurGroupMembersAttributeSource = (e) => {
        this.currentLdapStore.setGroupMembersAttributeSource(e.target.innerText);
    }

    initDirectoryTypeDefaultValues = () => {

        const value = this.currentLdapStore.ldapDirectoryType;

        switch (value) {
            case LdapDirectoryType.activeDirectory:
                this.currentLdapStore.setGroupObjectClass('group');
                this.currentLdapStore.setGroupObjectFilter('(objectCategory=Group)');
                this.currentLdapStore.setGroupNameAttribute('name');
                this.currentLdapStore.setGroupMembersAttribute('member');
                this.currentLdapStore.setUserMembershipAttribute('memberOf');
                break;
            case LdapDirectoryType.openLDAP:
                this.currentLdapStore.setGroupObjectClass('groupOfUniqueNames');
                this.currentLdapStore.setGroupObjectFilter('(objectClass=groupOfUniqueNames)');
                this.currentLdapStore.setGroupNameAttribute('cn');
                this.currentLdapStore.setGroupMembersAttribute('uniqueMember');
                this.currentLdapStore.setUserMembershipAttribute('memberOf');
                break;
            case LdapDirectoryType.customLDAPServer:
                this.currentLdapStore.setGroupObjectClass('');
                this.currentLdapStore.setGroupObjectFilter('');
                this.currentLdapStore.setGroupNameAttribute('');
                this.currentLdapStore.setGroupMembersAttribute('');
                this.currentLdapStore.setUserMembershipAttribute('');
                break;
        }
    }

    componentDidMount() {

        this.initDirectoryTypeDefaultValues();
    }

	render() {

        const groupSchemaSettingsSection = 
        this.currentLdapStore.synchronizationEnabled == true && this.currentLdapStore.advancedTeamAndRoleMappingEnabled == true ? 
            <div>
                <div className='sub-title' style={{paddingTop: '30px'}}>
                        {this.t('GROUP_SCHEMA_SETTINGS')} <HelpTooltip 
                            text={this.t('GROUP_SCHEMA_SETTINGS_HELP_TOOLTIP')}
                        />
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-additional-group-dn'
                        hintText={this.t('ADDITIONAL_GROUP_DN')}
                        floatingLabelText={this.t('ADDITIONAL_GROUP_DN')}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeAdditionalGroupDn}
                        onBlur={this.onBlurAdditionalGroupDn}
                        errorText={this.ldapValidator.additionalGroupDnValidationMessage}
                        value={this.currentLdapStore.additionalGroupDn}
                        helpTooltipText={<AdditionalGroupDnTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-group-object-class'
                        hintText={this.t('GROUP_OBJECT_CLASS')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('GROUP_OBJECT_CLASS')}
                                            required={true}/>}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeGroupObjectClass}
                        onBlur={this.onBlurGroupObjectClass}
                        errorText={this.ldapValidator.groupObjectClassValidationMessage}
                        value={this.currentLdapStore.groupObjectClass}
                        helpTooltipText={<GroupObjectSchemaTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-group-object-filter'
                        hintText={this.t('GROUP_OBJECT_FILTER')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('GROUP_OBJECT_FILTER')}
                                            required={true}/>}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeGroupObjectFilter}
                        onBlur={this.onBlurGroupObjectFilter}
                        errorText={this.ldapValidator.groupObjectFilterValidationMessage}
                        value={this.currentLdapStore.groupObjectFilter}
                        helpTooltipText={<GroupObjectFilterTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-group-name-attribute'
                        hintText={this.t('GROUP_NAME_ATTRIBUTE')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('GROUP_NAME_ATTRIBUTE')}
                                            required={true}/>}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeGroupNameAttribute}
                        onBlur={this.onBlurGroupNameAttribute}
                        errorText={this.ldapValidator.groupNameAttributeValidationMessage}
                        value={this.currentLdapStore.groupNameAttribute}
                        helpTooltipText={<GroupNameAttributeTooltip />}
                    />
                </div>
                <div className='sub-title' style={{paddingTop:  '30px'}}>
                    {this.t('MEMBERSHIP_SCHEMA_SETTINGS')} <HelpTooltip 
                                text={this.t('MEMBERSHIP_SCHEMA_SETTINGS_TOOLTIP')} />
                </div>
                <div className='form-row'>
                    <PortalTextBox
                        dataCy='txt-group-members-attribute'
                        hintText={this.t('GROUP_MEMBERS_ATTRIBUTE_MEMBER')}
                        floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('GROUP_MEMBERS_ATTRIBUTE_MEMBER')}
                                            required={true}/>}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeGroupMembersAttribute}
                        onBlur={this.onBlurGroupMembersAttribute}
                        errorText={this.ldapValidator.groupMembersValidationMessage}
                        value={this.currentLdapStore.groupMembersAttribute}
                        helpTooltipText={<GroupMemberAttributeTooltip />}
                    />
                    <PortalTextBox
                        dataCy='txt-user-membership-attribute'
                        hintText={this.t('USER_MEMBERSHIP_ATTRIBUTE_MEMBEROF')}
                        floatingLabelText={this.t('USER_MEMBERSHIP_ATTRIBUTE_MEMBEROF')}
                        width='47%'
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        onChange={this.onChangeUserMembershipAttribute}
                        onBlur={this.onBlurUserMembershipAttribute}
                        errorText={this.ldapValidator.userMemberShipValidationMessage}
                        value={this.currentLdapStore.userMembershipAttribute}
                        helpTooltipText={<GroupMemberOfAttributeTooltip />}
                    />
                </div>
                <div className='form-row'>
                    <GroupMembersAttributeOriginDropdownContainer                        
                        onChange={this.onChangeGroupMembersAttributeSource}
                        onBlur={this.onBlurGroupMembersAttributeSource}
                        groupMembersAttributeSource={this.currentLdapStore.groupMembersAttributeSource}
                        groupMembersAttributeSourceItems={this.currentLdapStore.groupMembersAttributeSourceItems}
                        disabled={this.currentLdapStore.createUpdateLDAPServersProgress}
                        helpTooltipText={this.t('LDAP_GROUP_MEMBER_ATTRIBUTE_ORIGIN_TOOLTIP')}
                        floatingLabelText={this.t('LDAP_GROUP_MEMBER_ATTRIBUTE_ORIGIN')}                       
                    />
                </div>
                <div className='sub-title' style={{paddingTop:  '30px'}}>
                    {this.t('ADVANCED_ROLE_MAPPING')} <HelpTooltip 
                                text={this.t('ADVANCED_ROLE_MAPPING_HELP_TOOLTIP')} />
                </div>
                <div style={{marginTop: 15}}>
                    <EditAdvancedRoleMappingButton ldapServerId={this.props.ldapServerId} / >
                </div>
            </div> : null
        
        return (
            <div>
                {groupSchemaSettingsSection}
            </div>
    )
  }
}
